import { Reveal, Overline } from "./Reveal";

const CHAPTERS = [
  {
    n: "01",
    t: "Choose the right stocks, at the right price",
    d: "Impartation sessions on identifying great businesses and buying them with a margin of safety — not gambling on hype.",
  },
  {
    n: "02",
    t: "Build your own financial strategy",
    d: "Coaching and mentoring with hands-on group support so the strategy is yours, repeatable and built to last.",
  },
  {
    n: "03",
    t: "Learn from real experience",
    d: "Diego shares his thought process and 25 years of market experience as a living reference point for your decisions.",
  },
  {
    n: "04",
    t: "Stay accountable, week after week",
    d: "Weekly and bi-weekly calls with a structured agenda, plus a single point of contact over WhatsApp whenever you need.",
  },
];

export default function Manifesto() {
  return (
    <section id="method" data-testid="manifesto-section" className="relative py-28 md:py-40">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-2xl mb-16 md:mb-24">
          <Reveal>
            <Overline>The Method</Overline>
            <h2 className="font-display text-4xl md:text-6xl lg:text-7xl tracking-tight leading-[0.95] text-white mt-5">
              Give a man a fish — or teach him to trade for life.
            </h2>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-white/10 border border-white/10 rounded-3xl overflow-hidden">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.08}>
              <div className="group relative bg-ink hover:bg-surface transition-colors duration-500 p-10 md:p-14 h-full overflow-hidden">
                <span className="absolute -top-6 right-4 font-display text-[9rem] leading-none text-white/[0.04] group-hover:text-burgundy/20 transition-colors duration-500 select-none pointer-events-none">
                  {c.n}
                </span>
                <span className="font-mono text-xs text-burgundy tracking-[0.2em]">
                  CHAPTER {c.n}
                </span>
                <h3 className="font-display text-3xl md:text-4xl text-white mt-4 leading-tight relative z-10">
                  {c.t}
                </h3>
                <p className="text-slate-400 mt-5 leading-relaxed relative z-10 max-w-md">
                  {c.d}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
